export { default } from './IconSvg'
export { primaryColor } from './primaryColor'
